"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip_1 = require("../../parts/Tooltip");
var utils_1 = require("../../../utils");
var sizes = [['100%', '85%'], ['80%', '83%%'], ['60%', '78%'], ['40%', '70%'], ['20%', '50%']];
function default_1(donut, donutCount, chartTooltip, initialRun) {
    var _a = donut.props, showTooltips = _a.showTooltips, children = _a.children, onClick = _a.onClick, onHide = _a.onHide, onShow = _a.onShow, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, showLabels = _a.showLabels, overrides = __rest(_a, ["showTooltips", "children", "onClick", "onHide", "onShow", "onMouseEnter", "onMouseLeave", "showLabels"]);
    var seriesTooltip = utils_1.typeChildren(children).tooltip;
    var tooltip = seriesTooltip || chartTooltip;
    var options = __assign({ className: 'donut-series' }, overrides);
    options.type = 'pie';
    options.tooltip = Tooltip_1.tooltipOptions({ showTooltips: showTooltips }, tooltip, true);
    options.size = overrides.size || sizes[donutCount][0];
    options.innerSize = overrides.innerSize || sizes[donutCount][1];
    if (initialRun) {
        options.events = utils_1.bindEventHandlers({ onClick: onClick, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, onShow: onShow, onHide: onHide });
    }
    if (showLabels === false) {
        options.dataLabels = { enabled: false };
    }
    else {
        options.dataLabels = {
            style: {
                color: 'contrast',
                fontSize: '12px',
                fontWeight: 'bold',
                textOutline: '0px contrast'
            }
        };
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=donutOptions.js.map